import { styled } from "@mui/material";

export const RootChartContainerSC = styled("div")(
  () => `
  display: flex;
  min-height: 330px;
  height: 100%;
  `
);
